import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { UserService } from './user.service';
import { isSessionJwt } from './session.utils';

export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const userService = inject(UserService);
  const router = inject(Router);

  const queryToken = route.queryParamMap.get('token');
  if (queryToken && isSessionJwt(queryToken)) {
    localStorage.setItem('token', queryToken);
    userService.refreshCurrentUser().subscribe();
  }

  if (auth.isTokenValid()) {
    if (!auth.currentUser()) {
      userService.emitUserFromLocalStorage();
    }
    return true;
  }

  if (isSessionJwt(localStorage.getItem('token'))) {
    return from(auth.refreshSession()).pipe(
      map((ok) => {
        if (ok) {
          if (!auth.currentUser()) {
            userService.emitUserFromLocalStorage();
          }
          return true;
        }
        localStorage.setItem('redirectUrl', state.url);
        return router.parseUrl('/connexion');
      })
    );
  }

  localStorage.setItem('redirectUrl', state.url);
  return router.parseUrl('/connexion');
};
